<template>
    <v-dialog
        v-model="dialog"  
        persistent 
        scrollable
        max-width="550px"
        transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-btn class="white--text" color="#0B3F67" v-on="on">Agregar<v-icon right>mdi-plus-box-outline</v-icon></v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle titulo="Agregar Actividad" @cancelar="cancelar"/>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                        <v-select
                            :items="tiposDeAccion"
                            v-model="accion"
                            item-value="id"
                            item-text="nombre"
                            label="Tipo de Actividad"
                            @change="actividadesSelect()"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" class="pb-0">
                        <v-select
                            :items="actividades"
                            v-model="actividad.tipoActividad"
                            :error-messages="tipoErrors"             
                            @change="$v.actividad.tipoActividad.$touch()"
                            @blur="$v.actividad.tipoActividad.$touch()"
                            required                            
                            label="Actividad"
                        ></v-select>
                    </v-col>
                    <v-col v-if="isOtro" cols="12" md="12" class="pt-0 pb-0">
                        <v-textarea
                            rows="3"
                            label="Nombre Actividad"
                            counter="100"
                            v-model="otro"
                            :error-messages="otroErrors"             
                            @change="$v.otro.$touch()"
                            @blur="$v.otro.$touch()"
                            required
                        >
                        </v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="pt-0 pb-0">
                        <v-textarea
                            rows="3"
                            label="Descripción"
                            counter="500"
                            v-model="actividad.descripcion"
                            :error-messages="descErrors"             
                            @change="$v.actividad.descripcion.$touch()"
                            @blur="$v.actividad.descripcion.$touch()"
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="pt-0 pb-0" v-if="accion == 1">
                        <v-textarea
                            rows="3"
                            label="Temas Tratados"
                            counter="500"
                            v-model="actividad.temasTratados"
                            :error-messages="temasErrors"             
                            @change="$v.actividad.temasTratados.$touch()"
                            @blur="$v.actividad.temasTratados.$touch()"
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0 pb-0" v-if="accion == 1">
                        <v-text-field
                            label="Cantidad de Personas"
                            v-model="actividad.cantidadPersonas"
                            v-mask="mask"
                            hint="Ingresar solo números"
                            :error-messages="cantErrors"             
                            @change="$v.actividad.cantidadPersonas.$touch()"
                            @blur="$v.actividad.cantidadPersonas.$touch()"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0 pb-0">
                        <v-text-field
                            label="Cantidad de Actividades"
                            v-model="actividad.cantidadActividades"
                            v-mask="mask"
                            hint="Ingresar solo números"
                            :error-messages="cantAcErrors"             
                             @change="$v.actividad.cantidadActividades.$touch()"
                             @blur="$v.actividad.cantidadActividades.$touch()"
                            required                        
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0" v-if="accion == 1">
                        <v-select
                            label="Participantes"
                            :items="participantes"
                            item-text="nombre"
                            item-value="id"
                            multiple
                            chips 
                            v-model="listParticipantes"
                            :error-messages="ParticipanteErrors"             
                            @change="$v.listParticipantes.$touch()"
                            @blur="$v.listParticipantes.$touch()"
                            required
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" class="pt-0 pb-0" v-if="accion == 1">
                        <v-text-field
                            label="Facilitador"
                            v-model="actividad.facilitador"
                            hint="Ingresar nombre Facilitador"
                            required                        
                        ></v-text-field>
                    </v-col>
                    <v-col :cols="colSize" class="pt-0 pb-0">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="fechaMoment"
                                    label="Fecha de la Actividad"
                                    prepend-inner-icon="mdi-calendar-month"
                                    readonly
                                    v-on="on"
                                    :error-messages="fechaErrors"
                                    @change="$v.fechaActividad.$touch()"
                                    @blur="$v.fechaActividad.$touch()"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="fechaActividad" locale="es-CR" @input="menu = false" :min="fechaMinima" :max="fechaMaxima"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0" v-if="accion == 1">
                        <v-radio-group 
                            v-model="actividad.modalidad"
                            row
                            mandatory>
                            <template v-slot:label>
                                <div class="text-md-h6">Modalidad</div>
                            </template>
                            <v-radio
                                v-for="m in modalidad"
                                :key="m.id"
                                :label="m.nombre"
                                :value="m.id"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0" v-if="anioConsulta > 2021 && accion == 1">
                        <v-file-input 
                            accept=".png, .jpg, .jpeg"
                            show-size 
                            counter  
                            v-model="archivoAct" 
                            label="Evidencia Actividad"
                            :error-messages="evidActErrors"
                            @change="$v.archivoAct.$touch()"
                            @blur="$v.archivoAct.$touch()">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0" v-if="anioConsulta > 2021 && accion == 1">
                        <v-file-input 
                            accept=".png, .jpg, .jpeg"
                            show-size 
                            counter  
                            v-model="archivoPart" 
                            label="Certificación de participación"
                            :error-messages="evidPartErrors"
                            @change="$v.archivoPart.$touch()"
                            @blur="$v.archivoPart.$touch()">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0">
                        <v-file-input 
                            accept=".png, .jpg, .jpeg"
                            show-size 
                            counter 
                            multiple 
                            v-model="archivos" 
                            :label="labelEvid"
                            :error-messages="evidErrors"
                            @change="$v.archivos.$touch()"
                            @blur="$v.archivos.$touch()">
                        </v-file-input>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" :disabled="loading" text @click.native="cancelar">Cancelar</v-btn>
                <v-btn color="#0B3F67" :loading="loading" text @click="agregarActividad">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import moment from "moment"
import { mask } from "vue-the-mask"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import { required, maxLength, requiredIf } from "vuelidate/lib/validators"
import axios from "@/axios.js";
//Custom validations
const maxFileSize = (files) => {
    if(files != null) {
        let maximo = files.length * (5 * 1024 * 1024);
        let total = 0;
        files.forEach(file => {
            total += file.size
        });        
        return total < maximo;
    }
    return false;
}
const maxSingleFileSize = (file) => {
    if(file === null) {
        return true;
    } else {
        let maximo = 5 * 1024 * 1024;
        return file.size < maximo;
    }
}
export default {
    directives: {
        mask,
    },
    components: {
      ModalTitle
    },
    mounted() {
        this.getDataAgregar();
        this.actividadesSelect();
    },
    computed: {
        fileSize() {
            return this.archivos != null ? this.archivos.length : 0;
        },
        fechaMoment () {
            return this.fechaActividad ? moment(this.fechaActividad).format('DD/MM/YYYY') : '';
        },
        tipoErrors () {
            const errors = []
            if (!this.$v.actividad.tipoActividad.$dirty) return errors
            !this.$v.actividad.tipoActividad.required && errors.push('Campo requerido')
            return errors
        },
        descErrors () {
            const errors = []
            if (!this.$v.actividad.descripcion.$dirty) return errors
            !this.$v.actividad.descripcion.required && errors.push('Campo requerido')
            !this.$v.actividad.descripcion.maxLength && errors.push('No debe exceder el tamaño permitido.')
            return errors
        },
        otroErrors(){
            const errors = []
            if(!this.$v.otro.$dirty) return errors
            !this.$v.otro.required && errors.push('Dato requerido')
            return errors
        },
        cantErrors () {
            const errors = []
            if (!this.$v.actividad.cantidadPersonas.$dirty) return errors
            !this.$v.actividad.cantidadPersonas.required && errors.push('Campo requerido')
            return errors
        },
        cantAcErrors () {
           const errors = []
           if (!this.$v.actividad.cantidadActividades.$dirty) return errors
           !this.$v.actividad.cantidadActividades.required && errors.push('Campo requerido')
           return errors
        },
        evidErrors() {
            const errors = []
            if (!this.$v.archivos.$dirty) return errors            
            !this.$v.archivos.required && errors.push('Por favor adjuntar evidencias.')
            !this.$v.archivos.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileSize + 'MB.')
            return errors
        },
        ParticipanteErrors () {
            const errors = []
            if (!this.$v.listParticipantes.$dirty) return errors
            !this.$v.listParticipantes.required && errors.push('Campo requerido')
            return errors
        },
        evidActErrors() {
            const errors = []
            if (!this.$v.archivoAct.$dirty) return errors            
            !this.$v.archivoAct.required && errors.push('Por favor adjuntar evidencias.')
            !this.$v.archivoAct.maxSingleFileSize && errors.push('El tamaño total debe ser menor a 1MB.')
            return errors
        },
        evidPartErrors() {
            const errors = []
            if (!this.$v.archivoPart.$dirty) return errors            
            !this.$v.archivoPart.required && errors.push('Por favor adjuntar evidencias.')
            !this.$v.archivoPart.maxSingleFileSize && errors.push('El tamaño total debe ser menor a 1MB.')
            return errors
        },
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        sucursal() {
            return this.$store.getters.sucursal;
        },
        usuario(){
            return this.$store.getters.usuario;
        },
        temasErrors () {
            const errors = []
            if (!this.$v.actividad.temasTratados.$dirty) return errors
            !this.$v.actividad.temasTratados.required && errors.push('Campo requerido')
            !this.$v.actividad.temasTratados.maxLength && errors.push('No debe exceder el tamaño permitido.')
            return errors
        },
        fechaErrors () {
            const errors = []
            if (!this.$v.fechaActividad.$dirty) return errors
            !this.$v.fechaActividad.required && errors.push('Campo requerido')
            return errors
        },
        isOtro(){
            return this.actividad.tipoActividad === "Otro" ? true : false;
        },
        anioConsulta() {
            return this.$store.getters.anioConsulta;
        },
        labelEvid() {
            return this.anioConsulta > 2021 && this.accion == 1 ? 'Evidencias de temas tratados' : 'Agregar Evidencias';
        },
        colSize() {
            return this.accion == 1 ? 12 : 6
        },
        fechaMaxima() {
            return `${this.anioConsulta}-12-31`;
        },
        fechaMinima() {
            return `${this.anioConsulta}-01-01`;
        },
    },
    data: () => ({
        loading: false,
        dialog: false,
        menu: false,
        mask: '####',
        actividad: {
            tipoActividad: '',
            descripcion: '',
            cantidadPersonas: '',
            cantidadActividades: '',
            indicador: '',
            temasTratados: '',
            modalidad: 0
        }, 
        archivos:[],
        fechaActividad: null,
        actividades: [],
        actividadesEduc:[
            "Taller",
            "Conversatorio",
            "Charla",
            "Curso",
            "Cine foro",
            "Feria de ambiente y salud",
            "Mesa redonda",
            "Foro",
            "Congreso",
            "Capacitacion",
            "Comunicaciones",
            "Información audiovisual y/o escrita complementada con preguntas generadoras, encuestas o debates",
            "Otro"
            ],
        otro : "",
        participantes: [],
        listParticipantes: [],
        archivoAct: null,
        archivoPart: null,
        modalidad: [],
        tiposDeAccion: [
            {
                id: 1,
                nombre: 'Educación Ambiental'
            },
            {
                id: 2,
                nombre: 'Acción de Reducción'
            }
        ],
        accion: 1,
        actividadesFosil:[
            "Adquisición de equipo más eficiente.",
            "Mantenimiento preventivo de la flotilla vehicular, maquinaria y/o equipo.",
            "Implementación de dispositivos (mecánicos) para aumentar la eficiencia.",
            "Definición de rutas más adecuadas para reducir consumos.",
            "Implementar iniciativas de movilidad sostenible.",
            "Acondicionar estacionamientos para bicicletas.",
            "Pizarras informativas.",
            "Compartir información asociada al parámetro por distintos medios: redes sociales, correo electrónico, chats, otros.",
            "Colocación de calcomanías.",
            "Incluir los vehículos de colaboradores y proveedores.",
            "Implementar iniciativas para mejorar el registro y control de los consumos.",
            "Sistemas para el control del consumo",
            "Campañas de comunicación",
            "Promover transporte compartido",
            "Promover iniciativas de movilidad sostenible",
            "Planificar las giras o gestiones de trabajo",
            "Definir rutas y el vehiculo mas adecuado",
            "Realizar varios trámites en un mismo viaje",
            "Medicion de consumo de combustibles en colaboradores / proveedores",
            "Reduccion de consumo por concepto de kilometraje",
            "Reduccion de consumo por concepto de viajes aereos"
            ],
        actividadesAguaRes:[
            "Sustituir productos de limpieza a biodegradables",
            "Utilizar trampas de grasa",
            "Reutilización de aguas tratadas",
            "Implementar el uso de biojardineras",
            "No vertido de residuos en fregaderos y desagues",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Colocación de calcomanías"
            ],
        actividadesAgua:[
            "Mejoras y mantenimiento preventivo del sistema de abastecimiento de agua",
            "Cambios de equipos y accesorios de ahorro de agua",
            "Cosecha de agua de lluvia",
            "Reutilización de agua",
            "Establecer horarios de uso adecuado de agua",
            "Ajustar la presión del agua",
            "Verificar la calibración del medidor",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos"
            ],
        actividadesEnergia:[
            "Uso de fuentes de energía renovables no convencionales",
            "Cambio a tecnologías de mayor eficiencia energética",
            "Aprovechamiento de luz natural",
            "Uso de colores claros en paredes, techo y mobiliario",
            "Utilizar los aires acondicionados a 24C",
            "Configurar el equipo de cómputo en el modo de ahorro de energía",
            "Techos y paredes verdes para la climatización de ambientes internos",
            "Desconectar equipos electronicos y electricos cuando no estan en uso",
            "Calibrar los medidores eléctricos",
            "técnicas para el aislamiento térmico de las instalaciones",
            "Sistemas de monitoreo y control de consumo de electricidad",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos"
            ],
        actividadesResiduos:[
            "Innovación en pro de la reutilización de los residuos",
            "Sustitución de materiales o insumos por otros con mayor capacidad de biodegradación",
            "Aplicación de técnicas o tecnologías limpias para el tratamiento y aprovechamiento de los residuos",
            "Aplicación de técnicas o tecnologias para reducir el impacto de residuos peligrosos",
            "Pizarras Informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos",
            "Colocación de calcomanías"
        ],
        actividadesCompraSost: [
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Colocación de calcomanías"
        ]
    }),
    validations: {
        actividad: {
            tipoActividad: {
                required
            },
            descripcion: {
                maxLength: maxLength(500),
                required
            },
            cantidadPersonas: {
                required: requiredIf(function(){
                    return this.accion == 1 ? true : false;
                })
            },
            cantidadActividades: {
                required
            },
            temasTratados:{
                maxLength: maxLength(500),
                required: requiredIf(function(){
                    return this.accion == 1 ? true : false;
                })
            }
        },
        archivos: {
            required,
            maxFileSize
        },
        otro: {
            required: requiredIf(function(){
                return this.actividad.tipoActividad === "Otro" ? true : false;
            })
        },
        listParticipantes: {
            required: requiredIf(function(){
                return this.anioConsulta > 2021 && this.accion == 1 ? true : false;
            }),
        },
        archivoAct: {
            maxSingleFileSize,
            required: requiredIf(function(){
                return this.anioConsulta > 2021 && this.accion == 1 ? true : false;
            }),
        },
        archivoPart: {
            maxSingleFileSize,
            required: requiredIf(function(){
                return this.anioConsulta > 2021 && this.accion == 1 ? true : false;
            }),
        },
        fechaActividad: {
            required
        }
    },
    methods: {
        getDataAgregar() {
            this.loading = true;
            axios.get('/educacionAmbiental/getDataAgregar')
            .then(response => {
                this.participantes = response.data.participantes;
                this.modalidad = response.data.modalidad;
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.loading = false;
            })
        },
        agregarActividad() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                this.loading = true;
                this.actividad.indicador = this.indicadorActual;
                var formData = new FormData();
                this.archivos.forEach(file => {
                    formData.append('archivos', file);
                });
                formData.append("otro", this.otro);    
                formData.append("actividad", JSON.stringify(this.actividad));
                formData.append("fechaActividad", this.fechaActividad);
                formData.append('idInstalacion',this.sucursal.id);
                formData.append("idUsuario", this.usuario.id);
                formData.append("indicador", this.indicadorActual);
                formData.append("participantes", this.listParticipantes);
                formData.append("evidActividad", this.archivoAct);
                formData.append("evidParticipacion", this.archivoPart);
                formData.append("tipoActividad", this.accion);
                axios.post("/instalaciones/agregarEducAccReduc", formData).then(response => {
                    this.cancelar();
                    this.$store.dispatch('noti',{mensaje: 'Actividad agregada', color:'success'});   
                    this.$emit('reload');
                    this.$emit('reloadAn');
                }).catch(error => {
                  if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                  } else {
                    if (error.request && error.request.status === 415) {
                      this.$store.dispatch('noti', {mensaje: error.response.data, color: 'error'});
                      this.loading = false;
                    } else {
                      this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se agregó la actividad', color:'error'});   
                      this.loading = false;  
                    } 
                  }        
                })
            }
        },
        actividadesSelect() {
            if(this.accion == 1) {
                this.actividades = this.actividadesEduc.sort();
            } else {
                let indicadorActual = parseInt(this.$store.getters.indicadorActual);
                let constantes = this.$store.getters.constantes;
                switch(indicadorActual) {
                    case constantes.indicadorCombustibles:
                        this.actividades = this.actividadesFosil.sort();
                        break;
                    case constantes.indicadorAguasResiduales:
                        this.actividades = this.actividadesAguaRes.sort();
                        break;
                    case constantes.indicadorAgua:
                        this.actividades = this.actividadesAgua.sort();
                        break;
                    case constantes.indicadorEnergia:
                        this.actividades = this.actividadesEnergia.sort();
                        break;
                    case constantes.indicadorContamiAdmosf:
                        this.actividades = this.actividadesFosil.sort();
                        break;
                    case constantes.indicadorResiduos:
                        this.actividades = this.actividadesResiduos.sort();
                        break;
                    case constantes.indicadorCompSostenibles:
                        this.actividades = this.actividadesCompraSost.sort();
                        break;
                }
                this.actividades.push("Otro")
            }
        },
        cancelar() {
            this.actividad = {};
            this.fechaActividad = null
            this.archivos=[];
            this.otro = "";
            this.listParticipantes = [];
            this.$v.actividad.$reset();  
            this.$v.archivos.$reset();
            this.$v.archivoAct.$reset();
            this.$v.archivoPart.$reset();
            this.$v.fechaActividad.$reset();
            this.$v.otro.$reset();
            this.$v.listParticipantes.$reset();
            this.dialog = false;
            this.loading = false;
            this.archivoPart = null;
            this.archivoAct = null;
        },
    },
}
</script>